import template from './ir.html';

/* @ngInject */
function IRController($log, CameraService, growl) {
  const vm = this;
  let growlMessage;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //
  vm.ir = {
    mode: null,
    btnDisabled: false,
    growlMessage: null
  };

  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = irGet;
  vm.irUpdate = irUpdate;
  vm.irReset = irReset;

  function irGet() {
    vm.ir.btnDisabled = true;
    CameraService.getIRCutFilter(vm.camId).then((data) => {
      vm.ir.mode = data.data.state;
    }, (err) => {
      $log.error(err);
    })
      .finally(() => {
        vm.ir.btnDisabled = false;
        if (growlMessage) {
          growlMessage.destroy();
          growl.success('Done!');
        }
      });
  }

  function irUpdate() {
    vm.ir.btnDisabled = true;
    growlMessage = growl.info('Setting IR');
    CameraService.setIRCutFilter(vm.camId, vm.ir.mode).then(() => {
      irGet();
    }, (err) => {
      $log.error(err);
      vm.ir.btnDisabled = false;
    });
  }

  function irReset() {
    vm.ir.btnDisabled = true;
    growlMessage = growl.info('Resetting IR');
    CameraService.resetIRCutFilter(vm.camId).then(() => {
      irGet();
    }, (err) => {
      $log.error(err);
      vm.ir.btnDisabled = false;
    });
  }
}

export default {
  name: 'ir',
  template,
  controller: IRController,
  controllerAs: 'IRCtrl',
  bindings: {
    camId: '<'
  }
};
